import type { MockedYetReportData } from './types'

// TODO: Improve tax calculation by getting rid of these fields
export const zeroData: MockedYetReportData = {
  businessExpenses: 0,
  capitalLosses: 0,
  palCarryforward: 0,
  iraDeduction: 0,
  hsaDeduction: 0,
  studentLoanInterestDeduction: 0,
  totalItemizedDeductions: 0,
  qbi: 0,
  isSstb: 0,
  w2WagesPaidByBusiness: 0,
  ubiaProperty: 0,
  numberOfDependentsForCare: 0,
  childCareExpenses: 0,
  foreignWages: 0,
  foreignBankInterest: 0,
  foreignCapitalGains: 0,
  foreignRentalRoyalty: 0,
  foreignPassiveIncome: 0,
  ctcPhaseoutThreshold: 0,
  otherStateTaxes: 0,
  stateAdditions: 0, // TODO: @max #should implement - Income state taxes but Feds don't
  stateSubtractions: 0, // TODO: @max #should implement - Income Feds tax but state doesn't
  stateDeduction: 0, // TODO: @max #must implement - State-specific deduction rules
  childAndDependentCareCredit: 0, // TODO: @maks #should implement
}
